module.exports = __webpack_public_path__ + "static/media/neg-peg-pie.038cc67e.svg";